export default (slug: string) => ({
  get reacted(): boolean {
    return document.cookie.split(";").some((c) => c.trim() === `reacted_post_${slug}=1`);
  },
});
